import { ResultModel } from '../models/result.model'
import { UserUploadedFileModel } from '../shared/models/service-models/UserUploadedFile.model'
import RequestFactory from './RequestFactory'

const GMAE2EURL = process.env.REACT_APP_GMAE2E_URL

const UserUploadedFileService = {
  uploadFile: async (file: File) => {
    const formData = new FormData()
    formData.append('file', file)

    return (await RequestFactory.upload(
      GMAE2EURL,
      `/api/user-uploaded-file/upload`,
      formData
    )) as Promise<ResultModel<UserUploadedFileModel>>
  },
}

export default UserUploadedFileService
